import { SecureStorage } from "@aparajita/capacitor-secure-storage";
import { BiometricAuth } from "@aparajita/capacitor-biometric-auth";
import { Preferences } from "@capacitor/preferences";
import { isNative } from "@/lib/native";

const KEY = "vf_refresh";
let access = null;

export const getAccess = () => access;

export async function saveTokens(d) {
  if (!isNative) return;
  access = d?.access_token || null;
  if (d?.refresh_token) await SecureStorage.set(KEY, d.refresh_token);
}

export async function getRefresh() {
  if (!isNative) return null;
  try { return await SecureStorage.get(KEY); } catch { return null; }
}

export async function clearTokens() {
  access = null;
  if (isNative) await SecureStorage.remove(KEY).catch(() => {});
}

export async function biometryAvailable() {
  if (!isNative) return false;
  try { return (await BiometricAuth.checkBiometry()).isAvailable; } catch { return false; }
}

export const getBioPref = async () => (await Preferences.get({ key: "vf_bio" })).value === "1";
export const setBioPref = (on) => Preferences.set({ key: "vf_bio", value: on ? "1" : "0" });

export async function biometricUnlock() {
  try {
    await BiometricAuth.authenticate({ reason: "Unlock VirtuForce", cancelTitle: "Use password", allowDeviceCredential: true });
    return true;
  } catch { return false; }
}
